import { TextWithMentions, Typography } from "@/components/ui";
import type { AssignmentApp } from "@/lib/data/requests/matters/matter-task";
import type { DirectoryUser } from "@/lib/types";
import { useEffect, useRef, useState } from "react";

const TASK_COMMENT_MAX_LINES = 4;

export const TaskCommentText = ({
  text,
  users,
  mentionedApps,
}: {
  text: string;
  users: DirectoryUser[];
  mentionedApps?: AssignmentApp[];
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const displayRef = useRef<HTMLDivElement>(null);
  const measureRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (measureRef.current && displayRef.current) {
      const measureElement = measureRef.current;
      const displayElement = displayRef.current;
      const lineHeight = parseInt(
        window.getComputedStyle(displayElement).lineHeight,
      );
      const maxHeight = lineHeight * TASK_COMMENT_MAX_LINES;
      const naturalHeight = measureElement.scrollHeight;

      setShowButton(naturalHeight > maxHeight);
    }
  }, [text]);

  return (
    <div>
      <div
        ref={measureRef}
        className="invisible absolute -top-9999 left-0"
        style={{
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          visibility: "hidden",
          width: "100%",
        }}
      >
        <Typography
          size="sm"
          className="text-muted-foreground whitespace-pre-wrap"
        >
          {text}
        </Typography>
      </div>
      <div ref={displayRef}>
        <Typography
          size="sm"
          className={`text-muted-foreground whitespace-pre-wrap ${
            isExpanded ? "" : "line-clamp-4"
          }`}
        >
          <TextWithMentions
            text={text}
            users={users}
            mentionedApps={mentionedApps}
          />
        </Typography>
      </div>
      {showButton && (
        <button
          type="button"
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
          className="text-primary dark:text-foreground mt-2 w-fit text-xs font-medium hover:underline"
        >
          {isExpanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};
